import React, { useState, useEffect, useContext } from "react";
import JudgeLayout from "../../layout/judgeLayout";
import {
  Steps,
  Empty,
  Typography,
  message,
  Button,
  Slider,
  Form,
  InputNumber,
  Row,
  Col,
  Result,
} from "antd";
import Axios from "axios";
import { useSearchParams } from "react-router-dom";
import { apiRoutes, environment } from "../../auth/apiRoute";
import { UserContext } from "../../auth/userContext";
import LoadingFrame from "../../layout/loadingFrame";
import ScrollButton from "../../components/scrollButton";
import "./dashboard.css";
const { Step } = Steps;
const { Paragraph, Title, Text } = Typography;
export default function JudgeDashboard(props) {
  console.log(props);
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [currentNomination, setCurrentNomination] = useState({});
  const [nominationsData, setNominationsData] = useState([]);
  const userContext = useContext(UserContext);
  const questions = [
    "1. Describe the employee’s overall job performance and dedication to his/her profession and to your Hotel. Please be specific and cite at least one example.",
    "2. Describe the interaction of the employee with his/her coworkers and/or with guests. Please cite specific examples of the employee’s positive impact on the guest experience at your hotel. ",
    "3. Please list any awards or recognition that the employee has received from the Hotel, management, guests, award organizations and/or peers.",
    "4. Please list any other reasons for nominating this employee for the Big Apple Stars Awards.",
  ];
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    getMyNominations();
  }, []);

  useEffect(() => {
    var defaultNomination = Object.assign({}, currentNomination, {});
    const qs = ["q1", "q2", "q3", "q4"];
    var userEmail = props.user.email;
    // for (const question of qs) {
    //   if (defaultNomination[question]) {
    //     if (!defaultNomination[question].hasOwnProperty("finalScores")) {
    //       defaultNomination[question]["finalScore"] = "";
    //     } else {
    //       defaultNomination[question]["finalScore"] =
    //         defaultNomination[question]["finalScores"][userEmail];
    //     }
    //   }
    // }
    console.log({ defaultNomination });
    form.setFieldsValue(defaultNomination);
  }, [currentNomination]);
  const [loading, setLoading] = useState(false);

  const getMyNominations = async () => {
    setLoading(true);
    var userEmail;
    if (searchParams.get("userEmail")) {
      userEmail = searchParams.get("userEmail");
    }
    try {
      const response = await Axios.post(apiRoutes[environment].shortList, {
        userEmail: userEmail,
      });

      if (response.status == 200) {
        console.log(response.data);
        var nominations = response.data;

        nominations = nominations.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        setNominationsData(nominations);
        setCurrentNomination(nominations[currentStep]);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const questionsAndAnswers = () => {
    var formItems = questions.map((question, index) => {
      return (
        <Row key={index + "q"}>
          <Col span={13}>
            <Paragraph>
              <Text>{question}</Text>
              <Paragraph className="admin-view-nomination-answer">
                {currentNomination["q" + (index + 1)] &&
                currentNomination["q" + (index + 1)].answer ? (
                  <p className="display-linebreak">
                    {" "}
                    {currentNomination["q" + (index + 1)].answer}
                  </p>
                ) : (
                  <Empty description={"No response"} />
                )}
              </Paragraph>
            </Paragraph>
          </Col>
          <Col md={6} sm={12}>
            <div
              style={{
                bottom: 0,
                display: "flex",
                height: "100%",
                flexDirection: "column",
                paddingBottom: "1em",
              }}
            >
              <div className="spacer"></div>
              <div style={{ display: "flex", alignItems: "baseline" }}>
                <Text style={{ paddingLeft: "2px" }}>Your score:</Text>
                <Form.Item
                  name={["q" + (index + 1), "finalScore"]}
                  // name={["q" + (index + 1), `finalScore[${props.user.email}]`]}
                >
                  <InputNumber
                    disabled={!currentNomination["q" + (index + 1)]}
                    min={0}
                    max={10}
                    step={0.1}
                    style={{ margin: "0 16px" }}
                    onChange={(value) => {
                      var newNominationData = currentNomination;

                      // if (
                      //   !newNominationData["q" + (index + 1)]["finalScores"]
                      // ) {
                      //   newNominationData["q" + (index + 1)]["finalScores"] = [
                      //     { email: props.user.email, score: value },
                      //   ];
                      // } else {
                      //   var record = newNominationData["q" + (index + 1)][
                      //     "finalScores"
                      //   ].find((item) => item.email == props.user.email);

                      //   if (record) {
                      //     record.score = value;
                      //   } else {
                      //     newNominationData["q" + (index + 1)][
                      //       "finalScores"
                      //     ].push({ email: props.user.email, score: value });
                      //   }
                      // }
                      // newNominationData["q" + (index + 1)]["finalScores"] = {
                      //   [props.user.email]: value,
                      // };

                      newNominationData["q" + (index + 1)].finalScore = value;
                      setCurrentNomination(newNominationData);
                    }}
                  />
                </Form.Item>
              </div>
            </div>
          </Col>
        </Row>
      );
    });

    return (
      <Form onFinish={onFinish} form={form}>
        NO. {currentStep + 1}
        <Title level={5} style={{ paddingLeft: "2px" }}>
          Score Range, Min: 0 , Max : 10
        </Title>
        {formItems} {footer()}
      </Form>
    );
  };

  const sider = () => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
        /* you can also use 'auto' behaviour
           in place of 'smooth' */
      });
    };

    const checkIfFinished = (nomination) => {
      var bool = true;
      for (var i = 1; i < 5; i++) {
        if (
          nomination["q" + i] &&
          nomination["q" + i].answer &&
          (!nomination["q" + i].hasOwnProperty("finalScore") ||
            !nomination["q" + i].finalScore)
        ) {
          bool = false;
        }
      }

      return bool;
    };

    var stepsOption = nominationsData.sort().map((nomination, index) => {
      var titleValue = "In Progress";
      if (currentStep < index) {
        titleValue = "Waiting";
      }

      if (checkIfFinished(nomination)) {
        titleValue = "Finished";
      }

      return (
        <Step
          key={index + nomination._id}
          title={titleValue}
          description={"No." + (index + 1) + " " + nomination.category}
        />
      );
    });

    return (
      <div style={{ color: "white" }}>
        <Steps
          progressDot
          direction="vertical"
          current={currentStep}
          onChange={(current) => {
            scrollToTop();
            setCurrentStep(current);
            setCurrentNomination(nominationsData[current]);
          }}
        >
          {stepsOption}
        </Steps>
      </div>
    );
  };
  const footer = () => {
    if (nominationsData) {
      var nominations = nominationsData;
      var total = nominationsData.length;
      const index = nominations.findIndex(
        (item) => item == currentNomination._id
      );
      return (
        <Col span={16}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              disabled={currentStep == 0}
              onClick={() => {
                console.log(nominationsData);

                if (currentStep == nominationsData.length) {
                  setCurrentStep(0);
                  setCurrentNomination(nominationsData[0]);
                } else {
                  setCurrentStep(currentStep - 1);
                  setCurrentNomination(nominationsData[currentStep - 1]);
                }

                form.resetFields();
              }}
            >
              {currentStep == total ? "Check Again" : "Previous"}
            </Button>

            <Form.Item>
              <Button
                htmlType="submit"
                disabled={currentStep == total}
                // onClick={() => {
                //   setCurrentStep(currentStep + 1);
                //   if (nominationsData[currentStep + 1]) {
                //     setCurrentNomination(nominationsData[currentStep + 1]);
                //   }
                // }}
              >
                {currentStep == total - 1
                  ? "Confirm & Finish"
                  : "Confirm & Next"}
              </Button>
            </Form.Item>
          </div>
        </Col>
      );
    }
  };

  const onFinish = (values) => {
    console.log({ values });
    console.log({ currentNomination });
    updateScore(currentNomination);
    setCurrentStep(currentStep + 1);
    form.resetFields();
    if (nominationsData[currentStep + 1]) {
      setCurrentNomination(nominationsData[currentStep + 1]);
    }
    console.log({ nominationsData });
  };

  const updateScore = async (newNomination) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].updateFinalScore,
        newNomination
      );

      if (response.status == 200) {
        message.success({
          content: "Scores have been updated. ",
          className: "messageBox",
        });
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  if (!props.isFinalJudgingNomination) {
    const year = new Date().getFullYear();
    return (
      <JudgeLayout>
        <Result
          status={"success"}
          title="Thanks for your time."
          extra={
            <Paragraph>
              The online final judging for {year} Big Apple Stars Awards is now
              closed.
            </Paragraph>
          }
        />
      </JudgeLayout>
    );
  }

  return (
    <JudgeLayout sidebar={sider()}>
      <LoadingFrame loading={loading}>
        {currentStep < nominationsData.length ? (
          <>
            <Text>
              Category:{" "}
              <Title level={2}>
                {currentNomination && currentNomination.category
                  ? currentNomination.category
                  : ""}
              </Title>
            </Text>
            {questionsAndAnswers()}
          </>
        ) : (
          <Result
            status="success"
            title="Thanks for your time!"
            extra={[
              <Button
                type="primary"
                key="console"
                onClick={() => {
                  setCurrentStep(0);
                  setCurrentNomination(nominationsData[0]);
                }}
              >
                Go back and review
              </Button>,
            ]}
          />
        )}
      </LoadingFrame>
      <ScrollButton />
    </JudgeLayout>
  );
}
